import SliderColumns from './slider-columns';

export default class SliderColumnsDesktop extends SliderColumns {
    constructor(...args) {
        super(...args);

    }
    _retrieveDOM() {
        super._retrieveDOM();

        this.dom.overflowContainerText = this.dom.component.querySelector(".overflow-container-text");
        this.dom.centeredWrapper = this.dom.component.querySelectorAll('.container-text-centeredWrapper');
    }
    _animate(){
        this._setCenteredWrapperHeight();

        // animation image
        this.animRounding.animate(this.params.next);

        this.dom.overflowContainerText.style.overflowY = "auto";

        // animation text
        let heightNextStep = this.dom.text[this.params.next].offsetHeight;

        this.animText.fromTo(this.dom.text[this.params.current], 0.6, {autoAlpha: 1}, {autoAlpha: 0, force3D:true, ease: Power3.easeInOut}, 0 )
                .call(()=>{
                    this.dom.overflowContainerText.scrollTop = 0;
                })
                .fromTo(this.dom.text[this.params.next], 0.6, {y: -heightNextStep, autoAlpha: 1}, {y: 0, force3D:true, ease: Power3.easeInOut}, 0.4 );

    }

    _setCenteredWrapperHeight(){

        for(let i = 0; i < this.dom.text.length; i++){
            let height = this.dom.text[i].offsetHeight;
            let parent = this.dom.text[i].parentElement; // is .container-text-centeredWrapper
            parent.style.height = height + 'px'
        }
    }

    _setSizeImg(){

        for (let i = 0; i < this.dom.containerImages.length; i++) {
            let widthImg = this.dom.containerImages[i].offsetWidth;
            let heightImg = this.dom.containerImages[i].offsetHeight;
            let image = this.dom.containerImages[i].querySelector('.inner');

            // TweenLite.to(image,0 , {height: heightImg, width: widthImg, x: "-50%", y: "-50%"} );
        }

    }

    resize(width, height) {
        this._setCenteredWrapperHeight()
        this._setSizeImg(this.params.current);
    }

    /*
    init() {
    }

    unbind() {
    }
    resize(width, height) {
    }
    */
}




// WEBPACK FOOTER //
// src/js/components/slider-columns/slider-columns.desktop.js